export { default } from './ComparisonLists';



// WEBPACK FOOTER //
// ./src/components/DataCentre/ComparisonLists/index.ts